import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useT } from '@transifex/react'
import swal from 'sweetalert2'

import { useDispatch } from 'react-redux'
import { login } from '../redux/authActions'
import qlocx from '../../../assets/qlocx.png'
import '../css/auth.css'

const LoginForm = () => {
  const t = useT()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const dispatch = useDispatch()

  const toggleModalButton = () => {
    swal
      .fire({
        title: t('Enter your email address'),
        text: t('We will send you a link to reset your password'),
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: t('Send'),
        cancelButtonText: t('Cancel'),
        showLoaderOnConfirm: true,
        confirmButtonColor: '#006E78',
        preConfirm: (text) => axios.get(`${window.MYQLOCX_API}/forgotpassword?email=${text}`).catch(() => ({ data: t('Something went wrong') })),
        allowOutsideClick: () => !swal.isLoading(),
      })
      .then((r) => {
        let text = t('We have sent you an email with a new password')
        if (r.value.data === t('Something went wrong')) {
          text = t('Something went wrong')
        }

        swal.fire({
          confirmButtonColor: '#006E78',
          text,
        })
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const onFormSubmit = (ev) => {
    ev.preventDefault()

    const { value: e } = document.querySelector('.login-form input')
    const { value: p } = document.querySelector('.login-form input[type="password"]')

    dispatch(login({ email: e.toLowerCase(), password: p }))
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onFormSubmit(e)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <form onSubmit={onFormSubmit} className="login-form">
      <div className="login-header">
        <img className="login-logo" alt="Qlocx Logo" src={qlocx} />
        <h3 className="login-title text-center">{t('Login')}</h3>
      </div>
      <div>
        <input placeholder={t('Username')} value={email} onChange={(e) => setEmail(e.target.value.trim())} />
      </div>
      <hr className="sub-hr-login" />
      <div>
        <input placeholder={t('Password')} value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
      </div>
      <hr className="sub-hr-login" />
      <div>
        <a className="forgot-password" onClick={toggleModalButton}>
          {t('Forgot password?')}
        </a>
      </div>
      <button className="login-btn" type="submit">
        {t('Login')}
      </button>
    </form>
  )
}

export default LoginForm
